import { z } from "zod";

export const TermSchema = z.object({
    id: z.number().positive().min(1),
    terms: z.string().max(4096).default(''),
    stageId: z.number().positive().min(1),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
});

export const TermDefaultSchema = TermSchema.extend({
    id: z.number().optional(),
    stageId: z.number().optional(),
    createdBy: z.number().optional(),
    createdOn: z.date().optional(),
    modifiedBy: z.number().optional(),
    modifiedOn: z.date().optional(),
});

export type Term = z.infer<typeof TermSchema>;